module.exports = __webpack_public_path__ + "static/img/5.d8f3912.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/13/sp/5.png
// module id = XImQ
// module chunks = 0